import { onValue, ref, set, update, remove} from 'firebase/database'
import {useState,useEffect, useRef} from 'react'
import { db } from '../firebase'
import io from 'socket.io-client';
import Swal from 'sweetalert2'
import OutputVisualization from './OutputVisualization';
import {getFirestore,collection,addDoc,getDocs,doc,getDoc,query,where,setDoc,deleteDoc, updateDoc,onSnapshot} from 'firebase/firestore';
import logo from "./Imagenes/Logo.png"

// --- Iconos Inline ---
const IconPlay = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
    <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
  </svg>
)

const IconPause = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
    <path fillRule="evenodd" d="M6.75 5.25a.75.75 0 01.75-.75H9a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H7.5a.75.75 0 01-.75-.75V5.25zm7.5 0A.75.75 0 0115 4.5h1.5a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H15a.75.75 0 01-.75-.75V5.25z" clipRule="evenodd" />
  </svg>
)

const IconVolumeOn = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06zM18.584 5.106a.75.75 0 011.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 11-1.06-1.06 8.25 8.25 0 000-11.668.75.75 0 010-1.06z" />
        <path d="M15.932 7.757a.75.75 0 011.061 0 6 6 0 010 8.486.75.75 0 01-1.06-1.061 4.5 4.5 0 000-6.364.75.75 0 010-1.061z" />
    </svg>
)

const IconVolumeOff = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06zM17.78 9.22a.75.75 0 10-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 101.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 101.06-1.06L20.56 12l1.72-1.72a.75.75 0 10-1.06-1.06l-1.72 1.72-1.72-1.72z" />
    </svg>
)

const IconArrowLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
)

const IconArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
    </svg>
)

// --- Componentes UX ---
const ProgressBar = ({ value, max }) => {
    const percentage = Math.min(Math.max((value / max) * 100, 0), 100);
    return (
        <div className="w-full bg-gray-700 h-2 rounded-full overflow-hidden mt-4 shadow-inner">
            <div 
                className="h-full bg-gradient-to-r from-blue-500 to-indigo-500 transition-all duration-200 ease-linear"
                style={{ width: `${percentage}%` }}
            />
        </div>
    );
};


const Inicio = () => {

    const [posicion, setPosicion] = useState(0)
    const [secuencia,setSecuencia]=useState([])
    const [nombresDisponibles,setNombresDisponibles]=useState([])
    const [nombreSelecc,setNombreSelecc]=useState("")
    const [tiempo,setTiempo]=useState(localStorage.getItem("Tiempo")||5)
    const [silenciado,setSilenciado]=useState(false)
    const [play,setPlay]=useState(false)
    const [showFormulario,setShowFormulario]=useState(false)
    
    const [id, setId] = useState(null);

    useEffect(()=>{
        //updateDoc(doc(db,"retratos","Q7S3J33N1wGUsMhagZSt"),{secuencia:[]})
    },[])

    useEffect(() => {
      // Asegúrate de que `window` está disponible
      if (typeof window !== 'undefined') {
        const queryParams = new URLSearchParams(window.location.search);
        const idParam = queryParams.get('id');
        setId(idParam);
      }
    }, []);

    useEffect(()=>{
        console.log(id)
    },[id])

    const onEnd=()=>{
        //setActivoHabla(0)
    }

    const [speaking, setSpeaking] = useState(false);
    const utteranceRef = useRef(null);

    const cancel = () => {
        if (typeof window !== 'undefined' && 'speechSynthesis' in window) {
            window.speechSynthesis.cancel();
            setSpeaking(false);
        }
    };

    const [voices, setVoices] = useState([]);

    useEffect(() => {
        const loadVoices = () => {
            const availableVoices = window.speechSynthesis.getVoices();
            setVoices(availableVoices);
        };

        loadVoices();
        
        if (typeof window !== 'undefined' && window.speechSynthesis) {
             window.speechSynthesis.onvoiceschanged = loadVoices;
        }
        
        return () => {
            if (typeof window !== 'undefined' && window.speechSynthesis) {
                window.speechSynthesis.onvoiceschanged = null;
            }
        } 
    }, []);

    const speak = ({ text }) => {
        if (typeof window !== 'undefined' && 'speechSynthesis' in window) {
            window.speechSynthesis.cancel();
            
            const textToSpeak = String(text);
            const utterance = new SpeechSynthesisUtterance(textToSpeak);
            utteranceRef.current = utterance;
            
            utterance.volume = 1;
            utterance.rate = 1;
            utterance.pitch = 1;
            utterance.lang = 'es-ES';

            if (voices.length > 0) {
                 const spanishVoice = voices.find(voice => voice.lang.includes('es-ES') || voice.lang.includes('es'));
                 if (spanishVoice) utterance.voice = spanishVoice;
            }

            utterance.onstart = () => setSpeaking(true);
            utterance.onend = () => {
                setSpeaking(false);
                onEnd();
            };
            utterance.onerror = (e) => {
                console.error("Speech error:", e);
                setSpeaking(false);
            };
            
            window.speechSynthesis.speak(utterance);
            window.speechSynthesis.resume();
        }
    };

    const unlockAudio = () => {
        if (typeof window !== 'undefined' && 'speechSynthesis' in window) {
            window.speechSynthesis.resume(); 
            const utterance = new SpeechSynthesisUtterance(" ");
            utterance.volume = 1; 
            utterance.rate = 1;
            utterance.onend = () => {};
            window.speechSynthesis.speak(utterance);
        }
    };

    /////////////////CONTEO TIEMPO////////////////////
    const [secs, setSeconds] = useState(tiempo);
    const [milisec, setmilisec] = useState(0);
    const [enviarAESP,setEnviarAESP]=useState(false) 

    const [editandoPosicion,setEditandoPosicion]=useState(false)
    const [posicionInput,setPosicionInput]=useState("")

    useEffect(()=>{
        setPosicionInput(posicion)
    },[posicion])

    useEffect(() => {
        let sampleInterval = setInterval(() => {
            if (play){
                if (milisec > 0) {
                    setmilisec(milisec - 20);
                } else {
                    if (secs > 0) {
                        setSeconds(secs - 1);
                        setmilisec(999);
                    } else {
                        // Tiempo agotado
                        setmilisec(0);
                        setSeconds(tiempo);
                        cancel(); 
                        handleAdelante(); 
                    }
                }
            }
        }, 20);
        return () => {
            clearInterval(sampleInterval);
        };
    });


    useEffect(()=>{
        if(secs==tiempo){
            // Deprecated logic
        }
    },[posicion])

    useEffect(()=>{
        if (!silenciado){
            cancel()
            speak({ text: secuencia[posicion] })
        }
    },[posicion])


    useEffect(()=>{
        cancel()
        setmilisec(0)
        setSeconds(tiempo)
        setPlay(false)
        let unsubscriberDatos=()=>{}
        if (id){
            unsubscriberDatos= onSnapshot(doc(db,"retratos",id),res=>{
                const datos=res.data()||{}
                setSecuencia(datos.secuencia||[])
                setPosicion(datos.ultimaPosicion||0)
                setNombreSelecc(datos.nombre||"")
            })
        }

        return ()=>{
            unsubscriberDatos()
        }

    },[id])

    useEffect(()=>{
        if (!play){
            setSeconds(tiempo)
            setmilisec(0)
        }
    },[play])

    useEffect(()=>{
    },[secuencia])
    const handleAtras=()=>{
        if (posicion-1>=0){
            updateDoc(doc(db,"retratos",id),{ultimaPosicion:posicion-1}).then(ok=>{
            })
        }
    }
    const handleAdelante=()=>{
        if (posicion+1<secuencia.length){
            //socket.emit("nuevaPosicion",secuencia[posicion])
            updateDoc(doc(db,"retratos",id),{ultimaPosicion:posicion+1}).then(ok=>{
            })
        }
    }
    const btnAdelante=()=>{
        unlockAudio();
        setPlay(false)
        handleAdelante()
    }
    const btnAtras=()=>{
        unlockAudio();
        setPlay(false)
        handleAtras()
    }
    const handleSetTiempo=(tiempo)=>{
        unlockAudio();
        setPlay(false)
        setSeconds(tiempo)
        setmilisec(0)
        cancel()
        localStorage.setItem("Tiempo",tiempo)
        setTiempo(tiempo)
    }
    const handlePlayBtn=()=>{
        unlockAudio();
        setPlay(!play)
    }


    const handleEnterInputPosicion=(val)=>{
        if (val=="Enter"){
            updateDoc(doc(db,"retratos",id),{ultimaPosicion:parseInt(posicionInput,10)-1}).then(()=>{
                setEditandoPosicion(false)
            })
        }
    }

    const progreso = 100 - ((secs + milisec / 1000) * 100 / tiempo);

  return (
    <div className='min-h-screen bg-gray-900 text-white flex flex-col items-center p-4 font-sans'>
        <div className='py-4 w-full flex items-center justify-center flex-col animate-fade-in-down'>
            <img
                src={logo}
                className='h-20 drop-shadow-lg'
                alt="Logo"
            />
            <p className='text-xs text-gray-400 mt-2 tracking-widest uppercase'>Gracias por tu confianza</p>
        </div>
        
        <div className='w-full max-w-4xl flex flex-col items-center flex-grow justify-center mb-10'>
            {showFormulario ? (
                <div className="w-full max-w-lg bg-gray-800 p-6 rounded-2xl shadow-2xl border border-gray-700 animate-fade-in-up">
                    <Formulario nombresUsados={nombresDisponibles} setShowFormulario={setShowFormulario}/>
                </div>
            ) : (
                <div className='w-full flex flex-col items-center gap-y-8'>
                    
                    {/* Tarjeta Principal de Visualización */}
                    <div className='bg-gray-800 w-full max-w-3xl rounded-3xl shadow-2xl p-8 border border-gray-700 relative overflow-hidden'>
                        
                        {/* Cabecera de la Tarjeta */}
                        <div className='flex justify-between items-start mb-6'>
                            <div className='flex flex-col'>
                                <span className='text-xs uppercase tracking-wider text-gray-500'>Retrato actual</span>
                                <span className='text-2xl font-bold text-gray-100'>{nombreSelecc || "Sin selección"}</span>
                            </div>
                            <button
                                onClick={()=>setSilenciado(!silenciado)}
                                className={`p-2 rounded-full transition-colors duration-200 ${silenciado ? "bg-red-500/20 text-red-400 hover:bg-red-500/30" : "bg-blue-500/20 text-blue-400 hover:bg-blue-500/30"}`}
                                title={silenciado ? "Activar voz" : "Silenciar voz"}
                            >
                                {silenciado ? <IconVolumeOff /> : <IconVolumeOn />}
                            </button>
                        </div>

                        {/* Visualizador de Números */}
                        <div className='flex items-center justify-between px-2 sm:justify-center gap-2 md:gap-12 my-8 w-full'>
                             {/* Número Anterior */}
                             <div className='flex flex-col items-center opacity-40 scale-75 blur-[1px] select-none min-w-[40px]'>
                                <span className='text-3xl md:text-4xl text-gray-400 font-bold'>{secuencia[posicion-1] || "-"}</span>
                            </div>

                            {/* Número Central (Activo) */}
                            <div className='relative flex flex-col items-center z-10 mx-2 flex-grow sm:flex-grow-0'>
                                <h1 className='text-7xl sm:text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-500 drop-shadow-2xl transition-all transform hover:scale-105 cursor-default text-center leading-none'>
                                    {secuencia[posicion] || "0"}
                                </h1>
                                
                                <div className='mt-2'>
                                    {editandoPosicion ? (
                                        <div className="flex items-center bg-gray-700 rounded-lg px-2 py-1">
                                            <input 
                                                className='bg-transparent text-white w-12 text-center text-sm font-bold outline-none' 
                                                value={posicionInput} 
                                                autoFocus
                                                onBlur={() => setEditandoPosicion(false)}
                                                onKeyDown={(e)=>handleEnterInputPosicion(e.key)} 
                                                onChange={(e)=>setPosicionInput(e.target.value)}
                                            />
                                            <span className="text-gray-400 text-xs">/ {secuencia.length}</span>
                                        </div>
                                    ) : (
                                        <button 
                                            onClick={()=>{if (nombreSelecc){setEditandoPosicion(true)}}}
                                            className='text-sm font-medium text-gray-500 hover:text-gray-300 transition-colors bg-gray-900/50 px-3 py-1 rounded-full'
                                        >
                                            {posicion + 1} <span className='text-gray-600'>/ {secuencia.length}</span>
                                        </button>
                                    )}
                                </div>
                            </div>

                             {/* Número Siguiente */}
                             <div className='flex flex-col items-center opacity-40 scale-75 blur-[1px] select-none min-w-[40px]'>
                                <span className='text-3xl md:text-4xl text-gray-400 font-bold'>{secuencia[posicion+1] || "-"}</span>
                            </div>
                        </div>

                        {/* Barra de Progreso */}
                        <div className='w-full mt-6'>
                             <ProgressBar value={progreso} max={100} />
                             <div className='flex justify-between items-center mt-2'>
                                <span className='text-xs text-gray-500 font-mono'>{play ? `${secs}s` : "Pausa"}</span>
                                <span className='text-xs text-gray-500 font-mono'>Intervalo: {tiempo}s</span>
                             </div>
                        </div>
                    </div>

                    {/* Controles Principales */}
                    <div className='flex items-center justify-center gap-6 w-full max-w-2xl'>
                        <button 
                            className='group bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-white p-4 rounded-full shadow-lg border border-gray-700 transition-all hover:scale-110 active:scale-95'
                            onClick={btnAtras}
                            title="Anterior"
                        >
                            <IconArrowLeft />
                        </button>

                        <button 
                            onClick={handlePlayBtn}
                            className={`p-6 rounded-full shadow-2xl transform transition-all hover:scale-105 active:scale-95 border-4 border-gray-800 ${play ? 'bg-gradient-to-r from-yellow-500 to-orange-500 text-white' : 'bg-gradient-to-r from-green-500 to-emerald-600 text-white'}`}
                        >
                            {play ? <IconPause /> : <IconPlay />}
                        </button>

                        <button 
                            className='group bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-white p-4 rounded-full shadow-lg border border-gray-700 transition-all hover:scale-110 active:scale-95'
                            onClick={btnAdelante}
                            title="Siguiente"
                        >
                            <IconArrowRight />
                        </button>
                    </div>

                    {/* Selector de Tiempo */}
                    <div className='bg-gray-800/50 p-4 rounded-xl border border-gray-700/50 flex flex-col items-center w-64 backdrop-blur-sm'>
                        <label className='text-xs text-gray-400 mb-2 uppercase tracking-wide font-bold'>Velocidad</label>
                        <input
                            value={tiempo}
                            type="range"
                            min={1}
                            max={20}
                            step={1}
                            onChange={(e)=>handleSetTiempo(e.target.value)}
                            className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500"
                        />
                        <div className='flex justify-between w-full mt-1 text-[10px] text-gray-500 font-mono'>
                            <span>1s</span>
                            <span>{tiempo}s</span>
                            <span>20s</span>
                        </div>
                    </div>
                </div>
            )}
        </div>

        <div className='w-full max-w-5xl mx-auto px-4 mt-8'>
            <OutputVisualization sequence={secuencia} positionToShow={posicion}/>
        </div>
        
        <div className='mt-8 text-center'>
             <label className='text-xs text-gray-600'>Desarrollado por: <span className='font-semibold text-gray-500'>Ing. Rodolfo Muñoz De la Rocha</span></label>
        </div>
    </div>
  )
}

const Formulario = ({nombresUsados,setShowFormulario}) => {
    const [nombre,setNombre]=useState("")
    const [secuencia,setSecuencia]=useState("")
    const [error,setError]=useState("")
    useEffect(()=>{
        setError("")
    },[nombre,secuencia])
    const handleGuardar=()=>{
        if (nombre.trim()==="" || secuencia.trim()===""){
            setError("Debes llenar ambos camos")
            return
        }
        const exist=nombresUsados.some(name=>name.toUpperCase().trim()===nombre.toUpperCase().trim())
        if (exist){
            setError("Usa un nombre distinto")  
            return
        }
        setError("")

        //////////////////IMPORTANTEupdateDoc(doc(db,"retratos",id),{ultimaPosicion:0,secuencia})
        setShowFormulario(false)
    }
    return (
    <div className='flex flex-col items-center w-full'>
        <h2 className='text-xl font-bold text-white mb-6 border-b border-gray-700 pb-2 w-full text-center'>Nuevo Retrato</h2>
        
        {error && <div className="bg-red-500/20 border border-red-500 text-red-200 px-4 py-2 rounded-lg mb-4 text-sm w-full text-center">{error}</div>}

        <div className='w-full space-y-4'>
            <div className='flex flex-col'>
                <label className='text-sm text-gray-400 mb-1'>Nombre del retrato</label>
                <input
                    value={nombre}
                    onChange={(e)=>setNombre(e.target.value)}
                    placeholder='Ej: Paisaje Montaña'
                    className='px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all'
                />
            </div>
            
            <div className='flex flex-col'>
                <label className='text-sm text-gray-400 mb-1'>Secuencia Numérica</label>
                <textarea
                    value={secuencia}
                    onChange={(e)=>setSecuencia(e.target.value)}
                    placeholder='Ej: 0, 2, 8, 55, 28'
                    rows={4}
                    className='px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all resize-none'
                />
                <span className='text-xs text-gray-500 mt-1'>Separar números por comas</span>
            </div>
        </div>

        <div className='flex gap-4 w-full mt-8'>
             <button 
                className='flex-1 py-2 rounded-lg border border-gray-600 text-gray-300 hover:bg-gray-700 transition-colors'
                onClick={() => setShowFormulario(false)}
            >
                Cancelar
            </button>
            <button 
                className='flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-2 rounded-lg font-medium shadow-lg transition-all transform hover:scale-105'
                onClick={handleGuardar}
            >
                Guardar
            </button>
        </div>
    </div>
  )
}

export default Inicio